import {
	Component,
	ChangeDetectionStrategy,
	Input,
	EventEmitter,
	Output,
} from '@angular/core';
import { IAttachedFile } from '@app/pages/cmms/interfaces/files.interfaces';
import { TableType } from '@app/pages/cmms/types';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';
import { FileViewerModalComponent } from '@shared/ui-components/au-file-loader/file-viewer-modal/file-viewer-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { AuExpansionPanelModule } from '@app/shared/ui-components/au-expansion-panel/au-expansion-panel.module';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'image-section',
	templateUrl: './image-section.component.html',
	styleUrls: ['./image-section.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [AuExpansionPanelModule, MatIconModule, MatButtonModule, NgxTolgeeModule],
})
export class ImageSectionComponent {
	@Input() set files(attachedFiles: IAttachedFile[]) {
		this.images = attachedFiles.filter(file => file.file.contentType.includes('image/'));
		this.isPanelOpen = !!this.images?.length;
	}

	@Output() addExistingFileClicked = new EventEmitter<{
		page: CmmsPages;
		tableType: TableType;
	}>();

	images: IAttachedFile[] = [];
	isPanelOpen: boolean;

	constructor(private dialog: MatDialog) {}

	attachImage(event) {
		event.stopPropagation();
		this.addExistingFileClicked.emit({
			page: CmmsPages.existingEntities,
			tableType: TableType.FILES,
		});
	}

	openImage(index: number) {
		return this.dialog.open(FileViewerModalComponent, {
			data: { files: this.images, index },
			backdropClass: 'au-modal-backdrop',
			panelClass: ['au-modal', 'no-max-width'],
		});
	}
}
